module.exports = __webpack_public_path__ + "media/images/lane/sign-85208b1d1b2c1bc31aadd7eae85937db.png";